module.exports = __webpack_public_path__ + "img/line.b28c2c08.png";